import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Swal from "sweetalert2";

import { useGetCustomerQuery } from "../../features/api/customers";
import { currentLoginStateSelector } from "../../features/auth/authSlice";
import useInitialState from "../../hooks/useInitialState";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import UnauthorizedRedirect from "../UnauthorizedRedirect";

export default function PrivateRoute() {
  const { loading } = useInitialState();
  const isLoggedIn = useSelector(currentLoginStateSelector);
  const { data: customer } = useGetCustomerQuery();

  if (loading) {
    return (
      <div style={{ marginTop: "20vh" }} className="d-flex  justify-content-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isLoggedIn) {
    if (customer && customer.detail) {
      Swal.fire({ title: "Profile not found!", text: "Please complete your profile before accessing USMCA.", icon: "error" }).then(() => {
        window.location = `${import.meta.env.VITE_MAIN_SITE_URL}`;
      });
      return <LoadingSpinner />;
    }
    return <Outlet />;
  }

  return <UnauthorizedRedirect />;
}
